import { useQuery } from '@tanstack/react-query';
import { fetchOrderTypes } from '@/api/orders';

/** Shared by the hook and the route loaders, so they fill one cache entry of `OrderType[]`. */
export const orderTypesQueryOptions = {
  queryKey: ['cascade-tracing', 'order-types'] as const,
  queryFn: () => fetchOrderTypes().then(res => res.data),
  staleTime: 5 * 60_000,
};

export function useOrderTypes() {
  return useQuery(orderTypesQueryOptions);
}
